import urlParameter from '@hc-frontend/shared-assets/src/js/utils/url/urlParameter'
import type { RedirectStatus } from './utils'

export default function renewalParam({ agent }: RedirectStatus): RedirectStatus {
  return {
    continue: agent != null && urlParameter('subId1') !== 'RENEWAL'
  }
}
